export function getActiveBlynHeaders(): Record<string, string> {
  if (typeof window === 'undefined') return {};
  try {
    if (window.localStorage.getItem('impersonation') === 'true') return {};
    const headers: Record<string, string> = {};
    const accountId = window.localStorage.getItem('rbac_selected_subtenant_id');
    const memberUserId = window.localStorage.getItem('rbac_selected_subtenant_member_external_user_id');
    
    if (accountId) headers['X-Active-Account-Id'] = accountId;
    if (memberUserId) headers['X-Active-User-Id'] = memberUserId;
    
    const userId = window.localStorage.getItem('userId');
    if (userId) headers['X-User-Id'] = userId;

    const token = window.localStorage.getItem('token');
    if (token) headers['session_token'] = token;
    
    return headers;
  } catch {
    return {};
  }
}

export async function blynFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const headers = new Headers(init?.headers);
  const activeHeaders = getActiveBlynHeaders();
  
  for (const [k, v] of Object.entries(activeHeaders)) {
    if (!headers.has(k)) {
      headers.set(k, v);
    }
  }

  // Prevent caching which might be causing the 404 when Network tab is closed
  if (!headers.has('Cache-Control')) {
    headers.set('Cache-Control', 'no-cache, no-store, must-revalidate');
  }
  if (!headers.has('Pragma')) {
    headers.set('Pragma', 'no-cache');
  }
  
  const url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;
  
  try {
    const res = await fetch(input, { ...init, headers, cache: 'no-store' });
    if (!res.ok) {
      console.error(`[blynFetch] Failed request to ${url} with status ${res.status}`);
    }
    return res;
  } catch (err) {
    console.error(`[blynFetch] Network error for ${url}:`, err);
    throw err;
  }
}
